import { createDedupedRefresh } from "shared-ui/utils/createDedupedRefresh";
import { refreshWithAccessTokenCookie } from "../utils/tokens";

export const dedupedRefresh = createDedupedRefresh({
  refresh: refreshWithAccessTokenCookie,
});
